import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    getAirspaceTableData, editAirspaceData, deleteAirspaceData, getAirspaceDataById,
    getRelevanceAircraftData,
    getAllStationData,
    getAirApproachControlTableData, editAirApproachControlData, deleteAirApproachControlData, getAirApproachControlDataById, 
} from "@/services";

const useFlightScheduleStore = defineStore("flightSchedule", {
    state: () => ({
        pageTitle: '',
        tableAllData: {},
        selectedTerminal: {
            startingTerminal: [],
            endTerminal: [],
            dockingTerminal: []
        },
        relevanceAircraftData: null, // 空域数据
        allStationData: null // 航空站数据
    }),
    actions: {
        async getTableAllData(type, params) {
            let result = {}
            switch(type) {
                case 'airspace': result = await getAirspaceTableData(params);break;
                case 'airApproachControl': case 'airlineEnquiry': result = await getAirApproachControlTableData(params);break;
            }
            this.tableAllData = result.data
        },
        async getAirspaceDataById(params) {
            let result = await getAirspaceDataById(params)
            return result.data
        },
        async getAirApproachControlDataById(params) {
            let result = await getAirApproachControlDataById(params)
            return result.data
        },
        async getAircraftDataById(params) {
            let result = await getAircraftDataById(params)
            return result.data
        },
        async getRelevanceAircraftData() {
            let result = await getRelevanceAircraftData()
            this.relevanceAircraftData = result.data
            // return result.data
        },
        async getAllStationData() {
            let result = await getAllStationData()
            this.allStationData = result.data
        },

        async editTableData(type, params) {
            let result = {}
            switch(type) {
                case 'airspace': result = await editAirspaceData(params);break;
                case 'airApproachControl': result = await editAirApproachControlData(params);break;
            }
            return result
        },
        async deleteTableData(type, params) {
            let result = {}
            switch(type) {
                case 'airspace': result = await deleteAirspaceData(params);break;
                case 'airApproachControl': result = await deleteAirApproachControlData(params);break;
            }
            return result
        },
    },
});

export default useFlightScheduleStore;
